export const normalizeRoleKey = (role = "") =>
  String(role).toLowerCase().replaceAll("_", "-");

export const isPhysiotherapistRole = (role) =>
  normalizeRoleKey(role) === "physiotherapist";

export const getDefaultOpService = (role) =>
  isPhysiotherapistRole(role) ? "ia" : "ia";

const serviceTypeMap = {
  ia: "Initial Assessment",
  physio_care: "Physio Care",
  progress_scale: "Progress Scale",
  gallery: "Gallery",
  packages: "Packages",
  progress_monitoring: "Progress Notes",
  sports: "Sports EMR",
  ortho: "Ortho EMR",
  neuro: "Neuro EMR",
  cardiopulmonary: "Cardiopulmonary EMR",
  cardio: "Cardiopulmonary EMR",
};

export const getEmrHeading = (serviceType) => serviceTypeMap?.[serviceType] || "EMR";

export const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
